import { MessageSquare, Bot } from "lucide-react";

export interface SessionListEntry {
  sessionId: string;
  agentId: string;
  title: string;
  subtitle: string;
  updatedAt?: string;
  thinkingLevel?: string | null;
  thinkingDefault?: string | null;
  allowUserThinkingOverride?: boolean;
  hasMessages: boolean;
  hasLiveRuntimeActivity?: boolean;
}

export function SessionList(params: {
  sessions: SessionListEntry[];
  selectedConversationId?: string;
  onSelect: (sessionId: string) => void;
}) {
  return (
    <div className="flex h-full flex-col gap-2">
      {params.sessions.map((session) => {
        const selected = session.sessionId === params.selectedConversationId;
        return (
          <button
            key={session.sessionId}
            type="button"
            onClick={() => params.onSelect(session.sessionId)}
            className="flex w-full flex-col gap-2 rounded-md border px-3 py-3 text-left transition-colors"
            style={{
              borderColor: selected ? "var(--accent)" : "var(--border)",
              background: selected ? "var(--accent-subtle)" : "var(--surface)",
            }}
          >
            <div className="flex items-center justify-between gap-3">
              <div className="flex min-w-0 items-center gap-2">
                <div
                  className="flex h-8 w-8 items-center justify-center rounded-full"
                  style={{ background: "var(--bg-accent)", color: "var(--text-strong)" }}
                >
                  <Bot size={14} />
                </div>
                <div className="min-w-0">
                  <div className="truncate text-sm font-medium" style={{ color: "var(--text-strong)" }}>
                    {session.title}
                  </div>
                  <div className="truncate text-xs" style={{ color: "var(--muted-foreground)" }}>
                    {session.subtitle}
                  </div>
                </div>
              </div>
              <div
                className="rounded-full px-2 py-1 text-[10px] uppercase tracking-wide"
                style={{
                  background: session.hasLiveRuntimeActivity ? "var(--accent-subtle)" : "var(--bg-accent)",
                  color: session.hasLiveRuntimeActivity ? "var(--accent)" : "var(--muted-foreground)",
                }}
              >
                {session.hasLiveRuntimeActivity ? "live" : session.hasMessages ? "active" : "new"}
              </div>
            </div>
            {session.updatedAt ? (
              <div className="flex items-center gap-2 text-[11px]" style={{ color: "var(--muted-foreground)" }}>
                <MessageSquare size={12} />
                {new Date(session.updatedAt).toLocaleString()}
              </div>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
